import React from 'react';
import ChangeOption from './ChangeOption';
import OptionsByLine from './OptionsByLine';
import OptionsByCard from './OptionsByCard';
import OptionsPage from '../../../common/OptionsPage';
import { find, get } from 'lodash';
import SimpleOptionCard from '../../../common/options/SimpleOptionCard';
import {
  EXTERIOR,
  WHEELS,
  INTERIOR,
  PACKAGES,
  OPTIONS,
  PACKAGES_AND_OPTIONS,
} from '../../../common/steps';

const getOptionsByCategory = (config, category) =>
  get(find(config.summary.options, { key: category }), 'options');

const PackagesAndOptions = ({ onDetails, options, analyticsKey }) => (
  <div className="math-box__option-grid">
    {options.map((option) => {
      const { packageOption } = option;
      const type = packageOption ? 'package' : 'option';
      return (
        <SimpleOptionCard
          key={option.code}
          option={option}
          disabled
          onDetails={onDetails}
          type={type}
          optionMarker={
            type === 'option'
              ? option.dealerInstalledLabel
              : option.optionMarker
          }
          analyticsKey={analyticsKey}
          checked={option.selected}
        />
      );
    })}
  </div>
);

const OptionsSummary = ({ config, pricing, analyticsKey }) => {
  const selectedColorOptions = getOptionsByCategory(config, 'exterior');

  const selectedWheelsOptions = getOptionsByCategory(config, 'wheels');

  const selectedInteriorOptions = getOptionsByCategory(config, 'interior');

  const selectedPackages = getOptionsByCategory(config, 'packages');

  const selectedOptions = getOptionsByCategory(config, 'options');

  const selectedPackagesAndOptions = getOptionsByCategory(
    config,
    PACKAGES_AND_OPTIONS
  );

  return (
    <>
      {selectedColorOptions && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={EXTERIOR}></ChangeOption>
          </div>
          <OptionsByLine selectedOptions={selectedColorOptions} />
        </div>
      )}
      {selectedWheelsOptions && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={WHEELS}></ChangeOption>
          </div>
          <OptionsByLine selectedOptions={selectedWheelsOptions} />
        </div>
      )}
      {selectedInteriorOptions && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={INTERIOR}></ChangeOption>
          </div>
          <OptionsByLine selectedOptions={selectedInteriorOptions} />
        </div>
      )}
      {selectedPackages && selectedPackages.length > 0 && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={PACKAGES}></ChangeOption>
            <div className="math-box__option-summary-price">
              {pricing.packagesOptionsTotal}
            </div>
          </div>
          <OptionsPage>
            {({ onDetails }) => (
              <OptionsByCard
                selectedOptions={selectedPackages}
                onDetails={onDetails}
                type="package"
                analyticsKey={`${analyticsKey}:packages`}
              />
            )}
          </OptionsPage>
        </div>
      )}
      {selectedOptions && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={OPTIONS}></ChangeOption>
            <div className="math-box__option-summary-price">
              {pricing.optionsTotal.text}
            </div>
          </div>
          <OptionsPage>
            {({ onDetails }) => (
              <OptionsByCard
                selectedOptions={selectedOptions}
                onDetails={onDetails}
                type="option"
                analyticsKey={`${analyticsKey}:options`}
              />
            )}
          </OptionsPage>
        </div>
      )}
      {selectedPackagesAndOptions && (
        <div className="math-box__option-summary">
          <div className="math-box__option-summary-bar">
            <ChangeOption stepKey={PACKAGES_AND_OPTIONS}></ChangeOption>
            <div className="math-box__option-summary-price">
              {pricing.packagesAndOptionsTotal}
            </div>
          </div>
          <OptionsPage>
            {({ onDetails }) => (
              <PackagesAndOptions
                onDetails={onDetails}
                options={selectedPackagesAndOptions}
                analyticsKey={`${analyticsKey}:options`}
              />
            )}
          </OptionsPage>
        </div>
      )}
    </>
  );
};

export default OptionsSummary;
